// extracted by mini-css-extract-plugin
export default {"sub":"PageLayout_sub__zlvn2","layout":"PageLayout_layout__KukJQ","content":"PageLayout_content__G+u6Q"};